import { Stack, styled } from "@mui/material";

export const Section = styled(Stack)(({ theme }) => (props) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '48px',
    direction: 'rtl',
    [theme.breakpoints.down('md')]: {
        padding: '24px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: ' 24px 12px',
    },
    [theme.breakpoints.down('xs')]: {
        padding: ' 12px 6px',
    },
}))